import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Input } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import Loader from 'components/AntEnhancement/Loader';
import HomeCard from 'components/cards/HomeCard';
import localeTranslator from 'library/Hocs/LocalTranslator';
import services from 'services';
import VisitPaths from './VisitPaths';
var DoctorQueue = function (props) {
    var homeService = services.homeService, permissionService = services.permissionService;
    var _a = homeService.useGetDoctorHomeData(props.date, props.doctor_id), data = _a.data, isSuccess = _a.isSuccess, isLoading = _a.isLoading;
    var _b = useState(data || []), appointments = _b[0], setAppointments = _b[1];
    var _c = useState(''), query = _c[0], setQuery = _c[1];
    useEffect(function () {
        if (!isSuccess || !data) {
            return;
        }
        setAppointments(function (prev) {
            var dataById = Object.fromEntries(data.map(function (appointment) { return [appointment.getId(), appointment]; }));
            var sameData = prev.length === data.length &&
                prev.every(function (appointment) {
                    var next = dataById[appointment.getId()];
                    return (next &&
                        appointment.getStatus() === next.getStatus() &&
                        appointment.getDisplayedStatus() === next.getDisplayedStatus());
                });
            return sameData ? prev : data;
        });
    }, [isSuccess, data]);
    var filtered = appointments.filter(function (appointment) {
        var _a, _b;
        if (!query.trim())
            return true;
        return (_b = (_a = appointment.getPatient()) === null || _a === void 0 ? void 0 : _a.getPrimaryPhone()) === null || _b === void 0 ? void 0 : _b.includes(query.trim());
    });
    return (_jsxs("div", { className: "home-queue", children: [_jsxs("div", { className: "home-doctor-head", children: [_jsx("h3", { className: "home-doctor-head__name", children: props.doctor_name }), props.doctor_specialization ? (_jsx("p", { className: "home-doctor-head__specialty", children: props.doctor_specialization })) : null] }), _jsx(Input, { className: "home-queue-search", allowClear: true, prefix: _jsx(PhoneOutlined, {}), placeholder: props.translate('searchPhoneInQueue'), value: query, onChange: function (e) { return setQuery(e.target.value); } }), _jsx(Loader, { className: "home-queue__loader", renderSpinner: isLoading, children: !isLoading && filtered.length === 0 ? (_jsx("div", { className: "home-queue-empty", children: props.translate('noAppointmentsToday') })) : (_jsx("div", { className: "home-queue-list", children: filtered.map(function (appointment) { return (_jsx(HomeCard, { appointment: appointment, children: permissionService.hasPermissionToChangeAppointmentStatus() ? (_jsx(VisitPaths, { appointment: appointment })) : null }, "appointment-".concat(appointment.getId()))); }) })) })] }));
};
export default localeTranslator(DoctorQueue, 'home');
